/* Scoop "I'm looking for..." finder. A floating button that opens a smart product search.
   Understands diets and everyday words (e.g. "gluten free snacks for kids") and shows live products. */
(function () {
  if (window.__scoopFinder) return; window.__scoopFinder = 1;
  if (/^\/(cart|checkouts?|account|challenge|password)/.test(location.pathname)) return;

  var BUR = '#7f2631', GOLD = '#b1882f', INK = '#1f1410', CREAM = '#fbf8f3';
  var DIET_PARAM = 'filter.p.m.scoop.dietary';

  /* Diet words -> Shopify diet filter value + diet collection */
  var DIETS = [
    { re: /\b(gluten[\s-]?free|gf|coeliac|celiac|no gluten)\b/, v: 'Gluten Free', c: 'gluten-free' },
    { re: /\b(dairy[\s-]?free|df|lactose[\s-]?free|no dairy)\b/, v: 'Dairy Free', c: 'dairy-free' },
    { re: /\b(vegan|plant[\s-]?based)\b/, v: 'Vegan', c: 'vegan' },
    { re: /\b(vegetarian)\b/, v: 'Vegetarian', c: null },
    { re: /\b(nut[\s-]?free|no nuts?|school safe|lunch ?box)\b/, v: 'Nut Free', c: 'nut-free' },
    { re: /\b(sugar[\s-]?free|no (added )?sugar|low sugar|unsweetened|diabetic)\b/, v: 'No Added Sugar', c: 'no-added-sugar' },
    { re: /\b(caffeine[\s-]?free|decaf|no caffeine)\b/, v: 'Caffeine Free', c: 'caffeine-free' },
    { re: /\b(grain[\s-]?free|paleo)\b/, v: 'Grain Free', c: null }
  ];

  /* Everyday words -> the best collection, plus better search words */
  var TOPICS = [
    { re: /\b(protein|gym|muscle|workout|whey)\b/, t: 'High protein', c: 'high-protein', q: 'protein' },
    { re: /\b(protein powders?|whey|shake)\b/, t: 'Protein powders', c: 'protein-powders', q: 'protein powder' },
    { re: /\b(keto|low[\s-]?carbs?|ketogenic)\b/, t: 'Keto and low carb', c: null, q: 'keto' },
    { re: /\b(kids?|children|lunch ?box|school)\b/, t: 'For kids', c: 'for-kids-not-only', q: '' },
    { re: /\b(snacks?|nibbles|munch)\b/, t: 'Snacks', c: 'snacks', q: '' },
    { re: /\b(chocolate|choc|cacao|cocoa)\b/, t: 'Chocolate', c: 'chocolate', q: 'chocolate' },
    { re: /\b(lollies|candy|sweets|gummies|gummy)\b/, t: 'Natural lollies', c: 'natural-vegan-gummies', q: '' },
    { re: /\b(gifts?|hampers?|present|birthday|christmas|corporate)\b/, t: 'Gifts and hampers', c: 'gift-hamper-cards', q: '' },
    { re: /\b(bak(e|ing)|flours?|cake|cookies|bread)\b/, t: 'Baking and flour', c: 'baking', q: '' },
    { re: /\b(breakfast|porridge|oats|muesli|granola|cereal)\b/, t: 'Breakfast', c: 'granola-muesli', q: '' },
    { re: /\b(nut ?butters?|peanut butter|almond butter|pb|spread)\b/, t: 'Nut butters', c: 'nut-butters', q: 'butter' },
    { re: /\b(tea|coffee|chai|matcha|latte)\b/, t: 'Tea and coffee', c: 'teas-coffee', q: '' },
    { re: /\b(dried fruit|mango|dates|apricots?|figs?)\b/, t: 'Dried fruit', c: 'dried-fruit', q: '' },
    { re: /\b(nuts?|seeds?|trail mix)\b/, t: 'Nuts and seeds', c: 'nuts-seeds', q: '' },
    { re: /\b(superfoods?|spirulina|maca|smoothie)\b/, t: 'Superfoods', c: 'superfoods', q: '' },
    { re: /\b(gut|fibre|fiber|probiotic|kefir|kombucha|sauerkraut)\b/, t: 'Gut health', c: null, q: '' },
    { re: /\b(skin ?care|face|clay|moisturi[sz]er|serum|oil for skin)\b/, t: 'Face care', c: 'face-care', q: '' },
    { re: /\b(cleaning|laundry|dishwash|detergent)\b/, t: 'Natural cleaning', c: 'natural-cleaning-laundry', q: '' },
    { re: /\b(pasta|rice|grains?|quinoa|lentils|beans)\b/, t: 'Pantry staples', c: 'pantry-provisions', q: '' },
    { re: /\b(honey|maple|syrup|sweetener)\b/, t: 'Honey and syrup', c: 'honey-syrup', q: '' }
  ];

  /* Words customers type that our products call something else */
  var SYN = {
    'choc': 'chocolate', 'pb': 'peanut butter', 'lollies': 'snakes', 'candy': 'snakes', 'sweets': 'snakes',
    'fiber': 'fibre', 'yoghurt': 'kefir', 'yogurt': 'kefir', 'porridge': 'oats', 'cacao nibs': 'nibs',
    'pumpkin seeds': 'pepitas', 'linseed': 'linseed', 'flaxseed': 'linseed', 'flax': 'linseed',
    'sultanas': 'sultana', 'nutella': 'hazelnut', 'protein bar': 'protein ball', 'energy balls': 'protein ball'
  };
  var STOP = /\b(i'?m|i am|im|looking|look|for|some|something|anything|a|an|the|want|wanting|need|needs|to|buy|get|my|me|with|and|or|please|do|you|have|any|good|best|nice|healthy|that|is|are|in|of|on|it|find|show|what|which|can|could|would|like|love|stuff|things?|products?|options?|ideas?)\b/g;

  var CHIPS = [
    ['High protein', 'protein'], ['Low sugar', 'no added sugar'], ['Gluten free', 'gluten free'],
    ['Vegan', 'vegan'], ['Keto', 'keto'], ['Lunchbox, nut free', 'nut free snacks for kids'],
    ['Nut butter', 'nut butter'], ['Chocolate treats', 'chocolate'], ['Gut health', 'gut health'],
    ['Gifts and hampers', 'gifts'], ['Baking', 'baking'], ['Tea and coffee', 'tea']
  ];
  var HINTS = ['protein for my smoothie', 'gluten free snacks', 'nut free lunchbox ideas', 'low sugar chocolate', 'a gift for a foodie', 'keto breakfast'];

  var css = '' +
    '.sfind-pill{position:fixed;left:50%;bottom:22px;transform:translate(-50%,24px);opacity:0;z-index:2147483000;display:flex;align-items:center;gap:10px;padding:13px 16px 13px 20px;border-radius:999px;background:' + BUR + ';color:#fff;box-shadow:0 12px 30px rgba(31,20,16,.28);font:inherit;font-size:15px;letter-spacing:.02em;cursor:pointer;border:0;transition:opacity .5s,transform .5s cubic-bezier(.22,1,.36,1);white-space:nowrap}' +
    '.sfind-pill.is-in{opacity:1;transform:translate(-50%,0)}' +
    '.sfind-pill svg{width:19px;height:19px;flex:0 0 19px;stroke:#e8dbc1;fill:none;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}' +
    '.sfind-pill .sfind-x{margin-left:4px;width:22px;height:22px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:rgba(255,255,255,.14);font-size:15px;line-height:1}' +
    '.sfind-pill:hover{box-shadow:0 14px 34px rgba(31,20,16,.36)}' +
    '@media (max-width:749px){.sfind-pill{bottom:84px;font-size:14px;padding:12px 14px 12px 17px}}' +
    '.sfind-ov{position:fixed;inset:0;z-index:2147483001;background:rgba(31,20,16,.45);opacity:0;pointer-events:none;transition:opacity .3s}' +
    '.sfind-ov.is-open{opacity:1;pointer-events:auto}' +
    '.sfind{position:fixed;z-index:2147483002;left:50%;top:9vh;width:min(720px,94vw);max-height:82vh;transform:translate(-50%,16px);opacity:0;pointer-events:none;background:' + CREAM + ';border-radius:18px;box-shadow:0 30px 80px rgba(31,20,16,.35);display:flex;flex-direction:column;overflow:hidden;transition:opacity .3s,transform .4s cubic-bezier(.22,1,.36,1);color:' + INK + '}' +
    '.sfind.is-open{opacity:1;transform:translate(-50%,0);pointer-events:auto}' +
    '@media (max-width:749px){.sfind{top:auto;bottom:0;width:100vw;max-height:88vh;border-radius:18px 18px 0 0;transform:translate(-50%,40px)}}' +
    '.sfind__top{padding:22px 22px 14px;border-bottom:1px solid rgba(31,20,16,.08);background:#fff}' +
    '.sfind__k{display:flex;justify-content:space-between;align-items:center;margin-bottom:12px}' +
    '.sfind__k span{font-size:12px;font-weight:700;letter-spacing:.3em;text-transform:uppercase;color:' + GOLD + '}' +
    '.sfind__close{border:0;background:none;font-size:26px;line-height:1;color:' + INK + ';cursor:pointer;padding:0 4px}' +
    '.sfind__row{display:flex;align-items:center;gap:10px;border:1.5px solid ' + BUR + ';border-radius:999px;padding:4px 6px 4px 16px;background:#fff}' +
    '.sfind__row svg{width:20px;height:20px;flex:0 0 20px;stroke:' + BUR + ';fill:none;stroke-width:1.8;stroke-linecap:round}' +
    '.sfind__in{flex:1;border:0;outline:0;font:inherit;font-size:17px;padding:10px 0;background:transparent;color:' + INK + ';min-width:0}' +
    '.sfind__go{border:0;border-radius:999px;background:' + BUR + ';color:#fff;font:inherit;font-size:13px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;padding:11px 16px;cursor:pointer}' +
    '.sfind__body{overflow-y:auto;padding:18px 22px 22px;-webkit-overflow-scrolling:touch}' +
    '.sfind__h{font-size:12px;font-weight:700;letter-spacing:.24em;text-transform:uppercase;color:#8a7a6e;margin:0 0 10px}' +
    '.sfind__chips{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:18px}' +
    '.sfind__chip{border:1px solid rgba(31,20,16,.16);background:#fff;border-radius:999px;padding:9px 14px;font:inherit;font-size:14px;color:' + INK + ';cursor:pointer;transition:border-color .2s,background .2s}' +
    '.sfind__chip:hover{border-color:' + GOLD + ';background:#fff8ec}' +
    '.sfind__links{display:flex;flex-direction:column;gap:8px;margin-bottom:18px}' +
    '.sfind__link{display:flex;justify-content:space-between;align-items:center;gap:12px;padding:13px 16px;border-radius:12px;background:' + BUR + ';color:#fff;text-decoration:none;font-size:15px}' +
    '.sfind__link.alt{background:#fff;color:' + INK + ';border:1px solid rgba(31,20,16,.12)}' +
    '.sfind__link b{font-weight:700}.sfind__link i{font-style:normal;opacity:.8}' +
    '.sfind__grid{display:grid;grid-template-columns:repeat(3,1fr);gap:12px}' +
    '@media (max-width:749px){.sfind__grid{grid-template-columns:repeat(2,1fr)}}' +
    '.sfind__p{display:block;text-decoration:none;color:' + INK + ';background:#fff;border-radius:12px;overflow:hidden;border:1px solid rgba(31,20,16,.08);transition:transform .25s,box-shadow .25s}' +
    '.sfind__p:hover{transform:translateY(-2px);box-shadow:0 10px 24px rgba(31,20,16,.1)}' +
    '.sfind__img{aspect-ratio:1/1;background:#fff;display:flex;align-items:center;justify-content:center}' +
    '.sfind__img img{width:84%;height:84%;object-fit:contain}' +
    '.sfind__t{padding:10px 12px 2px;font-size:14px;line-height:1.3;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:3.6em}' +
    '.sfind__pr{padding:0 12px 12px;font-size:14px;font-weight:700;color:' + BUR + '}' +
    '.sfind__pr s{color:#8a7a6e;font-weight:400;margin-left:6px}' +
    '.sfind__so{font-size:11px;font-weight:700;letter-spacing:.12em;color:#8a7a6e;text-transform:uppercase}' +
    '.sfind__empty{padding:18px;background:#fff;border-radius:12px;font-size:15px;line-height:1.5}' +
    '.sfind__foot{margin-top:18px;font-size:13px;color:#6b5d54;line-height:1.5}' +
    '.sfind__foot a{color:' + BUR + '}' +
    '.sfind__load{height:3px;background:linear-gradient(90deg,transparent,' + GOLD + ',transparent);background-size:200% 100%;animation:sfind-l 1s linear infinite;opacity:0;transition:opacity .2s}' +
    '.sfind__load.on{opacity:1}@keyframes sfind-l{from{background-position:200% 0}to{background-position:-200% 0}}' +
    'body.sfind-lock{overflow:hidden}';

  var SEARCH = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>';
  var SPARK = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M19.5 19.5 15.5 15.5"/><path d="M19 3v4M17 5h4"/></svg>';

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(v) { var n = parseFloat(v); return isNaN(n) ? '' : '$' + n.toFixed(2); }

  function analyse(raw) {
    var q = ' ' + raw.toLowerCase().replace(/[’']/g, "'").replace(/[^a-z0-9' -]/g, ' ') + ' ';
    var diets = DIETS.filter(function (d) { return d.re.test(q); });
    var topics = TOPICS.filter(function (t) { return t.re.test(q); });
    var rest = q;
    diets.forEach(function (d) { rest = rest.replace(d.re, ' '); });
    Object.keys(SYN).forEach(function (k) { rest = rest.replace(new RegExp('\\b' + k + '\\b', 'g'), SYN[k]); });
    rest = rest.replace(/\b(kids?|children|lunch ?box|school|gifts?|present|keto|low carbs?|gut health|gut)\b/g, ' ');
    rest = rest.replace(STOP, ' ').replace(/\s+/g, ' ').trim();
    if (!rest) topics.forEach(function (t) { if (!rest && t.q) rest = t.q; });
    if (!rest && diets.length && !topics.length) rest = '';
    return { diets: diets, topics: topics, terms: rest };
  }

  function collectionUrl(handle, diets) {
    var u = '/collections/' + (handle || 'all');
    if (diets.length) u += '?' + diets.map(function (d) { return encodeURIComponent(DIET_PARAM) + '=' + encodeURIComponent(d.v); }).join('&');
    return u;
  }

  function fetchProducts(terms) {
    if (!terms) return Promise.resolve([]);
    var u = '/search/suggest.json?q=' + encodeURIComponent(terms) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag,body';
    return fetch(u).then(function (r) { return r.json(); }).then(function (j) {
      return (j.resources && j.resources.results && j.resources.results.products) || [];
    }).catch(function () { return []; });
  }

  function dietQuery(diets) {
    return diets.map(function (d) { return encodeURIComponent(DIET_PARAM) + '=' + encodeURIComponent(d.v); }).join('&');
  }
  /* Where the full list lives: search with diet filters ticked, or the best collection */
  function pageUrl(a) {
    var t = a.topics.filter(function (x) { return x.c; })[0];
    if (a.terms) return '/search?type=product&q=' + encodeURIComponent(a.terms) + (a.diets.length ? '&' + dietQuery(a.diets) : '');
    if (t) return collectionUrl(t.c, a.diets);
    if (a.diets.length === 1 && a.diets[0].c) return '/collections/' + a.diets[0].c;
    return collectionUrl('all', a.diets);
  }
  /* Read the product cards from a real store page, so diet filters are exact */
  function fromPage(url) {
    return fetch(url).then(function (r) { return r.text(); }).then(function (h) {
      var d = new DOMParser().parseFromString(h, 'text/html'), out = [], seen = {};
      [].forEach.call(d.querySelectorAll('.card-wrapper'), function (c) {
        var a = c.querySelector('.card__heading a') || c.querySelector('a[href*="/products/"]');
        if (!a) return;
        var href = a.getAttribute('href').split('?')[0];
        if (seen[href] || href.indexOf('/products/') < 0) return; seen[href] = 1;
        var img = c.querySelector('.card__media img');
        var price = c.querySelector('.price__sale .price-item--sale') || c.querySelector('.price__regular .price-item--regular');
        var badge = (c.querySelector('.card__badge') || {}).textContent || '';
        out.push({ id: href, url: href, title: a.textContent.replace(/\s+/g, ' ').trim(), image: img ? (img.getAttribute('src') || '') : '',
          priceText: /sold out/i.test(badge) ? 'Sold out' : (price ? price.textContent.replace(/\s+/g, ' ').trim() : '') });
      });
      return out;
    }).catch(function () { return []; });
  }

  function search(a) {
    if (a.diets.length || (!a.terms && a.topics.some(function (t) { return t.c; }))) return fromPage(pageUrl(a));
    if (!a.terms) return Promise.resolve([]);
    return fetchProducts(a.terms).then(function (list) {
      if (list.length || a.terms.indexOf(' ') < 0) return list;
      /* Nothing for the whole phrase: try each word and merge */
      var words = a.terms.split(' ').filter(function (w) { return w.length > 2; }).slice(0, 3);
      return Promise.all(words.map(fetchProducts)).then(function (lists) {
        var seen = {}, out = [];
        lists.forEach(function (l) { l.forEach(function (p) { if (!seen[p.id]) { seen[p.id] = 1; out.push(p); } }); });
        return out;
      });
    });
  }

  var pill, ov, box, input, body, loader, timer, reqId = 0;

  function build() {
    var st = el('style'); st.textContent = css; document.head.appendChild(st);
    pill = el('button', 'sfind-pill', SPARK + '<span>I\'m looking for...</span><span class="sfind-x" role="button" aria-label="Hide">&times;</span>');
    pill.type = 'button'; pill.setAttribute('aria-label', 'Search the Scoop pantry');
    document.body.appendChild(pill);
    setTimeout(function () { pill.classList.add('is-in'); }, 1200);
    pill.addEventListener('click', function (e) {
      if (e.target.closest('.sfind-x')) { e.stopPropagation(); pill.remove(); try { sessionStorage.setItem('sfind-hide', '1'); } catch (x) {} return; }
      open();
    });

    ov = el('div', 'sfind-ov'); document.body.appendChild(ov);
    box = el('div', 'sfind');
    box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Find a product');
    box.innerHTML =
      '<div class="sfind__top"><div class="sfind__k"><span>What are you looking for?</span><button type="button" class="sfind__close" aria-label="Close">&times;</button></div>' +
      '<form class="sfind__row" role="search">' + SEARCH + '<input class="sfind__in" type="search" autocomplete="off" enterkeyhint="search" aria-label="Search"><button class="sfind__go" type="submit">Search</button></form></div>' +
      '<div class="sfind__load"></div><div class="sfind__body"></div>';
    document.body.appendChild(box);
    input = box.querySelector('.sfind__in'); body = box.querySelector('.sfind__body'); loader = box.querySelector('.sfind__load');
    input.placeholder = 'e.g. ' + HINTS[0];
    var hi = 0; setInterval(function () { if (!input.value) { hi = (hi + 1) % HINTS.length; input.placeholder = 'e.g. ' + HINTS[hi]; } }, 2800);

    box.querySelector('.sfind__close').addEventListener('click', close);
    ov.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box.classList.contains('is-open')) close(); });
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 260); });
    box.querySelector('form').addEventListener('submit', function (e) {
      e.preventDefault();
      var a = analyse(input.value);
      if (!input.value.trim()) return;
      location.href = (a.terms || a.diets.length || a.topics.some(function (t) { return t.c; })) ? pageUrl(a) : '/search?type=product&q=' + encodeURIComponent(input.value);
    });
    home();
  }

  function home() {
    body.innerHTML = '<p class="sfind__h">Popular right now</p><div class="sfind__chips">' +
      CHIPS.map(function (c) { return '<button type="button" class="sfind__chip" data-q="' + esc(c[1]) + '">' + esc(c[0]) + '</button>'; }).join('') +
      '</div><div class="sfind__foot">Type anything, like <b>"gluten free snacks for kids"</b> or <b>"protein for smoothies"</b>. Can\'t find it? Call us on <a href="tel:0867067374">(08) 6706 7374</a> or email <a href="mailto:contact@scoopwholefoodswa.com.au">contact@scoopwholefoodswa.com.au</a>.</div>';
    [].forEach.call(body.querySelectorAll('.sfind__chip'), function (b) {
      b.addEventListener('click', function () { input.value = b.getAttribute('data-q'); run(); input.focus(); });
    });
  }

  function run() {
    var raw = input.value.trim();
    if (raw.length < 2) { home(); return; }
    var a = analyse(raw), my = ++reqId;
    loader.classList.add('on');
    search(a).then(function (list) {
      if (my !== reqId) return;
      loader.classList.remove('on');
      var shown = list;
      var html = '';

      /* Shortcut links: the right collection with the right diet filters already ticked */
      var links = [];
      var dietNames = a.diets.map(function (d) { return d.v; }).join(' + ');
      a.topics.forEach(function (t) {
        if (t.c) links.push({ u: collectionUrl(t.c, a.diets), t: (dietNames ? dietNames + ' ' : '') + t.t.toLowerCase().replace(/^./, function (m) { return m.toUpperCase(); }) });
      });
      if (a.diets.length && !links.length) {
        var d0 = a.diets[0];
        links.push({ u: a.diets.length === 1 && d0.c ? '/collections/' + d0.c : collectionUrl('all', a.diets), t: 'Everything ' + dietNames });
      }
      if (a.topics.some(function (t) { return /Keto/.test(t.t); })) links.push({ u: '/search?type=product&q=keto', t: 'Keto granola, nuts and treats' });
      if (a.topics.some(function (t) { return /Gut/.test(t.t); })) links.push({ u: '/search?type=product&q=psyllium+OR+kefir+OR+sauerkraut+OR+kimchi+OR+kombucha', t: 'Fibre and fermented foods' });
      if (links.length) {
        html += '<div class="sfind__links">' + links.slice(0, 3).map(function (l, i) {
          return '<a class="sfind__link' + (i ? ' alt' : '') + '" href="' + l.u + '"><span>Shop <b>' + esc(l.t) + '</b></span><i>&rarr;</i></a>';
        }).join('') + '</div>';
      }

      if (shown.length) {
        html += '<p class="sfind__h">Products</p><div class="sfind__grid">' + shown.slice(0, 9).map(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=300';
          var from = p.price_min && p.price_max && p.price_min !== p.price_max ? 'From ' : '';
          var cmp = p.compare_at_price_max && parseFloat(p.compare_at_price_max) > parseFloat(p.price) ? '<s>' + money(p.compare_at_price_max) + '</s>' : '';
          return '<a class="sfind__p" href="' + p.url + '"><div class="sfind__img">' + (img ? '<img loading="lazy" src="' + img + '" alt="">' : '') + '</div>' +
            '<div class="sfind__t">' + esc(p.title) + '</div><div class="sfind__pr">' +
            (p.priceText ? esc(p.priceText) : (p.available === false ? '<span class="sfind__so">Sold out</span>' : from + money(p.price_min || p.price) + cmp)) + '</div></a>';
        }).join('') + '</div>';
        html += '<a class="sfind__link alt" style="margin-top:14px" href="' + pageUrl(a) + '"><span>See all results</span><i>&rarr;</i></a>';
      } else if (!links.length) {
        html += '<div class="sfind__empty">We could not find <b>' + esc(raw) + '</b> online. Try a simpler word, like <b>almonds</b> or <b>protein</b>, or ask us: we stock more in store than online. Call <a href="tel:0867067374">(08) 6706 7374</a>.</div>';
      }
      body.innerHTML = html || '';
      if (!html) home();
    });
  }

  function open() {
    ov.classList.add('is-open'); box.classList.add('is-open'); document.body.classList.add('sfind-lock');
    pill.style.visibility = 'hidden';
    setTimeout(function () { input.focus(); }, 80);
  }
  function close() {
    ov.classList.remove('is-open'); box.classList.remove('is-open'); document.body.classList.remove('sfind-lock');
    if (pill) pill.style.visibility = '';
  }

  function start() {
    var hidden = false; try { hidden = sessionStorage.getItem('sfind-hide') === '1'; } catch (x) {}
    build();
    if (hidden) pill.remove();
    /* Any link to #find opens the finder too */
    document.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('a[href="#find"]'); if (a) { e.preventDefault(); open(); } });
    window.ScoopFinder = { open: open };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
